import { colors } from "./colors.js"
import { belowViewPort } from "utils"

export const typography = {
  widgetLabel: {
    lineHeight: "19px",
    fontSize: "1rem",
    letterSpacing: 0.8,
    fontWeight: 400,
    // It is important that the labels wrap
    //Which otherwise will affect the RWD
    textWrap: "wrap",
    ...belowViewPort(1441, {
      fontSize: "0.75rem",
    }),
  },
  placeholder: {
    fontWeight: 600,
    letterSpacing: 0,
    fontSize: 16,
    lineHeight: "24px",
  },
  mainText: {
    textTransform: "uppercase",
    fontWeight: 600,
    fontSize: "2rem",
    lineHeight: "38px",
    color: colors.grey500,
    ...belowViewPort(1441, { fontSize: "1.8rem" }),
  },
  title: {
    textTransform: "uppercase",
    fontWeight: 600,
    fontSize: "1.5rem",
    lineHeight: "38px",
    color: colors.grey500,
    ...belowViewPort(1441, { fontSize: "1.25rem" }),
  },
  formHeading: {
    fontSize: 18,
    lineHeight: "22px",
    textTransform: "uppercase",
    color: colors.primaryBlueGrey,
    fontWeight: 500,
    paddingLeft: 8,
    borderLeft: `4px solid ${colors.primaryBlueGrey}`,
    ...belowViewPort(1441, {
      fontSize: "1rem",
    }),
  },
  helpText: {
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "22px",
    color: "#0000007A",
    whiteSpace: "pre-line",
    ...belowViewPort(1441, {
      fontSize: "0.75rem",
    }),
  },
  cardTitle: {
    fontSize: "1.375rem",
    fontWeight: 400,
    color: colors.white,
  },
  sectionTitle: {
    fontWeight: 500,
    fontSize: 22,
    lineHeight: "27px",
    color: colors.black,
  },
  sideBarSubHeading: {
    fontSize: "1.8rem",
    fontWeight: 500,
    ...belowViewPort(1441, { fontSize: "1.125rem" }),
  },
  sideBarNormalText: {
    fontSize: "1.25rem",
    fontWeight: 400,
    ...belowViewPort(1441, { fontSize: "0.75rem" }),
  },
  linkText: {
    textDecoration: "none",
    border: "none",
    color: colors.primaryBlueGrey,
    outline: "none",
    fontSize: "1rem",
    ...belowViewPort(1441, { fontSize: "0.675rem" }),
  },
  disclaimer: {
    fontSize: "0.875rem",
    fontStyle: "italic",
    fontWeight: 400,
  },
  navMenuItemStyle: {
    fontSize: "1rem",
    textTransform: "uppercase",
    borderLeft: "4px solid transparent",
    flexGrow: 2,
    ...belowViewPort(1441, { fontSize: "0.875rem" }),
  },
  tableHeader: {
    textTransform: "uppercase",
    textAlign: "left",
    lineHeight: "24px",
    fontSize: "1rem",
    fontWeight: 600,
    position: "sticky",
    top: 0,
    zIndex: 0,
    color: "var(--resbird-table-header-cell-color)",
    ...belowViewPort(1441, { fontSize: "0.75rem" }),
  },
  listItem: {
    padding: "10px 40px",
    fontSize: "1rem",
    fontWeight: 400,
    ...belowViewPort(1441, { fontSize: "0.75rem" }),
  },
  accordionTitle: {
    textTransform: "uppercase",
    fontWeight: 500,
    fontSize: "1.5rem",
    ...belowViewPort(1441, { fontSize: "1.25rem" }),
  },
  regularText: {
    fontSize: "1rem",
    ...belowViewPort(1441, {
      fontSize: "0.75rem",
    }),
  },
}
